import { OBJECT_TYPE } from '../constants/objectTypes';
export function hasProperty(crmObject, propertyName) {
  return Boolean(crmObject.properties && propertyName in crmObject.properties);
}
/**
 * Returns the value of @propertyName in @crmObject.
 *
 * If @propertyName is not present:
 *   - returns undefined when @defaultValue is not provided.
 *   - returns @defaultValue otherwise.
 * @param crmObject The CRM object
 * @param propertyName The property name
 * @param defaultValue Optional default value if @propertyName is not found in @crmObject
 */
export function getPropertyValue(crmObject, propertyName, defaultValue) {
  if (hasProperty(crmObject, propertyName)) {
    return crmObject.properties[propertyName].value;
  }
  return defaultValue;
}
const NAME_PROPERTY = {
  [OBJECT_TYPE.CAMPAIGN]: 'hs_name',
  [OBJECT_TYPE.MARKETING_SMS]: 'hs_name',
  [OBJECT_TYPE.MARKETING_EVENT]: 'hs_event_name',
  [OBJECT_TYPE.MARKETING_EMAIL]: 'hs_name',
  [OBJECT_TYPE.FORM]: 'hs_name'
};
export function getName(crmObject, defaultValue) {
  const {
    objectTypeId
  } = crmObject;
  return getPropertyValue(crmObject, NAME_PROPERTY[objectTypeId], defaultValue);
}